import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={52}
    height={52}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect
        fill="#F4F5F9"
        fillRule="nonzero"
        opacity={0.183}
        width={52}
        height={52}
        rx={4}
      />
      <rect fill="#EEF4FF" width={52} height={52} rx={4} />
      <path
        d="M13.58 10a1.08 1.08 0 0 0-1.09 1.08v30.835a1.08 1.08 0 0 0 1.09 1.08H31.3a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V11.08A1.08 1.08 0 0 0 38.48 10h-24.9Z"
        stroke="#5590FF"
        fill="#D4E4FF"
        fillRule="nonzero"
        strokeLinejoin="round"
      />
      <path
        d="M31.3 42.996c1.704 0 3.093-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.165-3.53 1.351-5.51 1.356l-.09-.06Z"
        fill="#5590FF"
        fillRule="nonzero"
        opacity={0.5}
      />
      <path
        d="M39.57 37.037s.05 2.625-2.62 4.708c-1.601 1.207-3.55 1.246-5.53 1.25M17 17.5h2-2ZM20 17.5h15-15ZM17 21.5h2-2ZM20 21.5h15-15ZM17 25.5h2-2ZM17 29.5h2-2ZM20 25.5h15-15ZM20 29.5h15-15Z"
        stroke="#5590FF"
        strokeLinecap="round"
      />
      <path
        stroke="#5590FF"
        strokeLinecap="square"
        d="M17.5 7.5v4M31.5 7.5v4M20.5 7.5v4M34.5 7.5v4"
      />
    </g>
  </svg>
);
export default SvgIcNote;
